import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';

export const getPortalComponents = () => {
  const virtualDomNode = document.createElement('div');

  const ContentRendered = ((props) => ReactDOM.createPortal(props.children, virtualDomNode));

  class ContentPlaceholder extends React.PureComponent {

    static propTypes = {
      component: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node,
      ]),
    };

    static defaultProps = {
      component: 'div',
    };

    processRef = (node) => {
      const domNode = ReactDOM.findDOMNode(node);
      if (domNode) {
        domNode.append(virtualDomNode);
      }
    };

    render() {
      const { component, ...rest } = this.props;

      return React.createElement(component, {
        ...rest,
        ref: (node) => {
          this.processRef(node);
          const { ref } = rest;
          if (ref) {
            if (typeof ref === 'function') {
              ref(node);
            } else {
              ref.current = node;
            }
          }
        },
      });
    }

  }

  return {
    ContentPlaceholder,
    ContentRendered,
  };
};
